import "./SuchanaPage.css";
import Footer from "../components/Footer/Footer";

function SuchanaPage() {
  return (
    <div className="suchana-page">
      <div className="suchana-page__content">
        अहिले कुनै सुचनाहरु उपलब्द छैन
      </div>
    </div>
  );
}

export default SuchanaPage;
